/**
 * The API client is a wrapper around the API implementation and allows us to easily switch between different API implementations.
 */
export * from '@api/graphql-client'
